import { render, staticRenderFns } from "./EmpiPix.vue?vue&type=template&id=706724a7&scoped=true"
import script from "./EmpiPix.vue?vue&type=script&lang=js"
export * from "./EmpiPix.vue?vue&type=script&lang=js"
import style0 from "./EmpiPix.vue?vue&type=style&index=0&id=706724a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706724a7",
  null
  
)

export default component.exports